const baseTemplate = [
  { name: '存储类型', key: 'kind', type: 'text', maxLength: 50, disabled: true },
  { name: '数据库类型', key: 'type', type: 'text', maxLength: 50, disabled: true },
  { name: '数据源名称', key: 'name', type: 'text', maxLength: 50 },
  { name: '数据源描述', key: 'desc', type: 'text', maxLength: 100 },
  { name: '是否可用', key: 'enabled', type: 'select', options: [{ label: '是', value: 1 }, { label: '否', value: 0 }] }
]
const baseData = {
  kind: '',
  type: '',
  kindId: '',
  typeId: '',
  name: '',
  desc: '',
  enabled: '',
  module: 1 // 1:源数据源/2:目标数据源
}
const Text = {
  templateInfo: [
    ...baseTemplate,
    { name: 'IP', key: 'ip', type: 'text', maxLength: 50 },
    { name: '端口号', key: 'port', type: 'text', maxLength: 50 },
    { name: '存储目录', key: 'instance', type: 'text', maxLength: 50 },
    { name: '用户名', key: 'user', type: 'text', maxLength: 50 },
    { name: '密码', key: 'password', type: 'password', maxLength: 100, placeholder: '请输入密码' },
    { name: '编码', key: 'encodingId', type: 'select', options: [] }
  ],
  data: {
    ...baseData,
    ip: '',
    port: '',
    instance: '',
    user: '',
    password: '',
    encodingId: ''
  }
}
export default {
  MYSQL: {
    templateInfo: [
      ...baseTemplate,
      { name: '主机ip', key: 'ip', type: 'text', maxLength: 100 },
      { name: '端口', key: 'port', type: 'text', maxLength: 50 },
      { name: '实例名', key: 'instance', type: 'text', maxLength: 50 },
      { name: '用户名', key: 'user', type: 'text', maxLength: 50 },
      { name: '密码', key: 'password', type: 'password', maxLength: 100, placeholder: '请输入密码' },
      { name: '编码', key: 'encodingId', type: 'select', options: [] },
      { name: '驱动', key: 'driverId', type: 'select', options: [] }
    ],
    data: {
      ...baseData,
      ip: '',
      port: '3306',
      instance: '',
      user: '',
      password: '',
      encodingId: '',
      driverId: ''
    }
  },
  SQLSERVER: {
    templateInfo: [
      ...baseTemplate,
      { name: '主机ip', key: 'ip', type: 'text', maxLength: 100 },
      { name: '端口', key: 'port', type: 'text', maxLength: 50 },
      { name: '实例名', key: 'instance', type: 'text', maxLength: 50 },
      { name: '用户名', key: 'user', type: 'text', maxLength: 50 },
      { name: '密码', key: 'password', type: 'password', maxLength: 100 },
      { name: '编码', key: 'encodingId', type: 'select', options: [] },
      { name: '驱动', key: 'driverId', type: 'select', options: [] }
    ],
    data: {
      ...baseData,
      ip: '',
      port: '1433',
      instance: '',
      user: '',
      password: '',
      encodingId: '',
      driverId: ''
    }
  },
  MONGODB: {
    templateInfo: [
      ...baseTemplate,
      { name: '主机', key: 'ip', type: 'text', maxLength: 100 },
      { name: '模式', key: 'mode', type: 'select', maxLength: 50, options: [{ label: 'single ', value: '单机' }, { label: 'cluster ', value: '集群' }] },
      { name: '实例名称', key: 'instance', type: 'text', maxLength: 100 },
      { name: '用户名', key: 'user', type: 'text', maxLength: 50 },
      { name: '密码', key: 'password', type: 'password', maxLength: 100, placeholder: '请输入密码' }
    ],
    data: {
      ...baseData,
      ip: '',
      mode: '',
      instance: '',
      user: '',
      password: ''
    }
  },
  HBASE: {
    templateInfo: [
      ...baseTemplate,
      { name: 'Zookeeper地址', key: 'ip', type: 'text', maxLength: 100 },
      { name: '分布式模式', key: 'mode', type: 'select', maxLength: 50, options: [{ label: 'single ', value: '单机' }, { label: 'cluster ', value: '集群' }] },
      { name: 'Zookeeper端口号', key: 'port', type: 'text', maxLength: 50 },
      { name: 'Hbase数据存储目录', key: 'instance', type: 'text', maxLength: 50 }
    ],
    data: {
      ...baseData,
      ip: '',
      mode: '',
      port: '',
      instance: ''
    }
  },
  KAFKA: {
    templateInfo: [
      ...baseTemplate,
      { name: 'Server', key: 'ip', type: 'text', maxLength: 50 },
      { name: 'Topic', key: 'instance', type: 'text', maxLength: 50 }
    ],
    data: {
      ...baseData,
      ip: '',
      instance: ''
    }
  },
  EXCEL: Text,
  TXT: Text,
  CSV: Text,
  hdfs: {
    templateInfo: [
      ...baseTemplate,
      { name: 'DefaultFs', type: 'text', maxLength: 50, disabled: true },
      { name: '存储目录', type: 'text', maxLength: 50, disabled: true },
      { name: '用户名', type: 'text', maxLength: 50 }
    ],
    data: {
      ...baseData,
      ip: '',
      instance: '',
      name: ''
    }
  },
  files: {
    templateInfo: [
      ...baseTemplate,
      { name: 'IP', type: 'text', maxLength: 50, disabled: true },
      { name: '端口', type: 'text', maxLength: 50, disabled: true },
      { name: '存储目录', type: 'text', maxLength: 50 },
      { name: '用户名', type: 'text', maxLength: 50 },
      { name: '密码', type: 'password', maxLength: 100, placeholder: '请输入密码' },
      { name: '编码', type: 'select', options: [] }
    ],
    data: {
      ...baseData,
      ip: '',
      port: '',
      instance: '',
      user: '',
      password: '',
      encodingId: ''
    }
  },
  oss: {
    templateInfo: [
      ...baseTemplate,
      { name: 'EndPoint', type: 'text', maxLength: 50, disabled: true },
      { name: 'Port', type: 'text', maxLength: 50, disabled: true },
      { name: 'Bucket', type: 'text', maxLength: 50 },
      { name: 'AccessKey', type: 'text', maxLength: 100 },
      { name: 'SecretKey', type: 'text', maxLength: 100 }
    ],
    data: {
      ...baseData,
      ip: '',
      port: '',
      Instance: '',
      username: '',
      password: ''
    }
  },
  solr: {
    templateInfo: [
      ...baseTemplate,
      { name: 'Zookeeper地址', type: 'text', maxLength: 50, disabled: true }
    ],
    data: {
      ...baseData,
      ip: ''
    }
  },
  fts: {
    templateInfo: [
      ...baseTemplate,
      { name: '主机', type: 'text', maxLength: 50, disabled: true },
      { name: '端口', type: 'text', maxLength: 50, disabled: true },
      { name: '用户名', type: 'text', maxLength: 50 },
      { name: '密码', type: 'password', maxLength: 100, placeholder: '请输入密码' },
      { name: '模式', type: 'select', maxLength: 50, options: [{ label: 'single ', value: '单机' }, { label: 'cluster ', value: '集群' }] },
      { name: '编码', type: 'select', options: [] }
    ],
    data: {
      ...baseData,
      ip: '',
      port: '',
      username: '',
      password: '',
      mode: '',
      encodeId: ''
    }
  }
}
